// Palette comes from
// https://www.figma.com/file/8hviGiukYiE00M3DZCQSUl/Shippo-Brand-Colors-3.0-Final?
const namedPalette2023 = {
    primary: '#1F7A54',
    secondary: '#01474F',
    backgroundEmphasized: '#ffffff',
    primaryButtonHover: '#1A4C38',
    secondaryHover: '#F7FBFC',
    backgroundDeemphasized: '#EBF1F4',
    primaryDisabled: '#8FBCA9',
    secondaryDisabled: '#7FA2A6',
    backgroundChipBadge: '#EBF1F4',
    borders: '#DFE8EC',
    hoverFocus: '#ABEDD2',
    borderFocus: '#26D990',
    selectedBackground: '#D6F5E8',
    text: {
        default: '#112229',
        secondary: '#547C8C',
        inverse: '#ffffff',
        disabled: '#425B66',
    },
    specialUse: {
        default: '#C32D22',
        hover: '#A33129',
        disabled: '#E09590',
    },
    accent: {
        foreground: {
            error: '#C32D22',
            informational: '#3C3CDD',
            success: '#1F7A54',
            warning: '#F2B300',
            notice: '#6124cc',
        },
        background: {
            error: '#FFF5F5',
            informational: '#E5E5FF',
            success: '#D6F5E8',
            warning: '#FFEEBD',
            notice: '#f2ebff',
        },
    },
};
const roundedColors = {
    crimsonRoundDown: namedPalette2023.accent.background.error,
    crimsonRoundUp: namedPalette2023.accent.foreground.error,
    cyanRoundDown: namedPalette2023.accent.background.informational,
    cyanRoundUp: namedPalette2023.accent.foreground.informational,
    grayRoundDown: namedPalette2023.borders,
    grayRoundUp: namedPalette2023.secondary,
    blueRound: namedPalette2023.secondary,
    kellyRoundDown: namedPalette2023.accent.background.success,
    kellyRoundUp: namedPalette2023.accent.foreground.success,
    northStarRound: namedPalette2023.primary,
    yellowRoundDown: namedPalette2023.accent.background.warning,
    yellowRoundUp: namedPalette2023.accent.foreground.warning,
    violetRoundDown: namedPalette2023.accent.background.notice,
    violetRoundUp: namedPalette2023.accent.foreground.notice,
};
const designSystemColors = Object.assign({ white: namedPalette2023.text.inverse, transparent: 'transparent', 
    // crimson10: '#FCEEF1',
    // crimson20: '#FACDD7',
    // crimson30: '#F7A1B3',
    // crimson40: '#F4718D',
    // crimson50: '#EB476A',
    // crimson60: '#E32651',
    // crimson70: '#C7143B',
    // crimson80: '#A60D24',
    // crimson90: '#800A1B',
    // crimson100: '#610512',
    crimson10: roundedColors.crimsonRoundDown, crimson20: roundedColors.crimsonRoundDown, crimson30: roundedColors.crimsonRoundDown, crimson40: roundedColors.crimsonRoundDown, crimson50: roundedColors.crimsonRoundUp, crimson60: roundedColors.crimsonRoundUp, crimson70: roundedColors.crimsonRoundUp, crimson80: roundedColors.crimsonRoundUp, crimson90: namedPalette2023.specialUse.hover, crimson100: namedPalette2023.specialUse.hover, 
    // cyan10: '#ECF9FE',
    // cyan20: '#B2EAFF',
    // cyan30: '#69D5FF',
    // cyan40: '#26BEF9',
    // cyan50: '#00AFF3',
    // cyan60: '#009FDD',
    // cyan70: '#007FB1',
    // cyan80: '#045F82',
    // cyan90: '#004966',
    // cyan100: '#013347',
    cyan10: roundedColors.cyanRoundDown, cyan20: roundedColors.cyanRoundDown, cyan30: roundedColors.cyanRoundDown, cyan40: roundedColors.cyanRoundDown, cyan50: roundedColors.cyanRoundUp, cyan60: roundedColors.cyanRoundUp, cyan70: roundedColors.cyanRoundUp, cyan80: roundedColors.cyanRoundUp, cyan90: roundedColors.cyanRoundUp, cyan100: roundedColors.cyanRoundUp, 
    // gray10: '#F7FBFC',
    // gray20: '#E9F1F5',
    // gray30: '#CFDEE6',
    // gray40: '#B8CED9',
    // gray50: '#7B99A8',
    // gray60: '#5C7B8A',
    // gray70: '#4C6774',
    // gray80: '#425B66',
    // gray90: '#2E434D',
    // gray100: '#1F2D34',
    gray10: namedPalette2023.secondaryHover, gray20: namedPalette2023.backgroundDeemphasized, gray30: roundedColors.grayRoundDown, gray40: roundedColors.grayRoundDown, gray50: roundedColors.grayRoundDown, gray60: roundedColors.grayRoundUp, gray70: roundedColors.grayRoundUp, gray80: roundedColors.grayRoundUp, gray90: roundedColors.grayRoundUp, 
    // gray100: '#1F2D34', // text default
    gray100: namedPalette2023.text.default, 
    // blue10: '#EBF1FF',
    // blue20: '#B3CAFF',
    // blue30: '#8DB0FF',
    // blue40: '#759FFF',
    // blue50: '#5488FF',
    // blue60: '#316CF4',
    // blue70: '#1D51C1',
    // blue80: '#103B9E',
    // blue90: '#0F2C70',
    // blue100: '#061F59',
    blue10: roundedColors.blueRound, blue20: roundedColors.blueRound, blue30: roundedColors.blueRound, blue40: roundedColors.blueRound, blue50: roundedColors.blueRound, blue60: roundedColors.blueRound, blue70: roundedColors.blueRound, blue80: roundedColors.blueRound, blue90: roundedColors.blueRound, blue100: roundedColors.blueRound, 
    // kelly10: '#F2FFEB',
    // kelly20: '#D4FBBC',
    // kelly30: '#B3F48B',
    // kelly40: '#93E467',
    // kelly50: '#71D147',
    // kelly60: '#58BC36',
    // kelly70: '#3FAA2D',
    // kelly80: '#30881E',
    // kelly90: '#226015',
    // kelly100: '#174111',
    kelly10: roundedColors.kellyRoundDown, kelly20: roundedColors.kellyRoundDown, kelly30: roundedColors.kellyRoundDown, kelly40: roundedColors.kellyRoundDown, kelly50: roundedColors.kellyRoundUp, kelly60: roundedColors.kellyRoundUp, kelly70: roundedColors.kellyRoundUp, kelly80: roundedColors.kellyRoundUp, 
    // kelly90: '#226015', // primary hover
    // kelly100: '#226015',
    kelly90: namedPalette2023.primaryButtonHover, kelly100: namedPalette2023.primaryButtonHover, 
    // northStar10: '#F4FAEA',
    // northStar20: '#DFF0C1',
    // northStar30: '#C9E698',
    // northStar40: '#B3DC6B',
    // northStar50: '#A0D249',
    // northStar60: '#87BD28',
    // northStar70: '#72A022',
    // northStar80: '#5B8217',
    // northStar90: '#3E5C0A',
    // northStar100: '#304213',
    northStar10: roundedColors.northStarRound, northStar20: roundedColors.northStarRound, northStar30: roundedColors.northStarRound, northStar40: roundedColors.northStarRound, northStar50: roundedColors.northStarRound, northStar60: roundedColors.northStarRound, northStar70: roundedColors.northStarRound, northStar80: roundedColors.northStarRound, northStar90: roundedColors.northStarRound, northStar100: roundedColors.northStarRound, 
    // yellow10: '#FFFBEB',
    // yellow20: '#FFF4CC',
    // yellow30: '#FAE79E',
    // yellow40: '#F9DC6C',
    // yellow50: '#F9CC53',
    // yellow60: '#F7A708',
    // yellow70: '#F09000',
    // yellow80: '#D68101',
    // yellow90: '#B36206',
    // yellow100: '#834C02',
    yellow10: roundedColors.yellowRoundDown, yellow20: roundedColors.yellowRoundDown, yellow30: roundedColors.yellowRoundDown, yellow40: roundedColors.yellowRoundDown, yellow50: roundedColors.yellowRoundUp, yellow60: roundedColors.yellowRoundUp, yellow70: roundedColors.yellowRoundUp, yellow80: roundedColors.yellowRoundUp, yellow90: roundedColors.yellowRoundUp, yellow100: roundedColors.yellowRoundUp, 
    // yellow10: '#FFFBEB',
    // yellow20: '#FFF4CC',
    // yellow30: '#FAE79E',
    // yellow40: '#F9DC6C',
    // yellow50: '#F9CC53',
    // yellow60: '#F7A708',
    // yellow70: '#F09000',
    // yellow80: '#D68101',
    // yellow90: '#B36206',
    // yellow100: '#834C02',
    violet10: roundedColors.violetRoundDown, violet20: roundedColors.violetRoundDown, violet30: roundedColors.violetRoundDown, violet40: roundedColors.violetRoundDown, violet50: roundedColors.violetRoundUp, violet60: roundedColors.violetRoundUp, violet70: roundedColors.violetRoundUp, violet80: roundedColors.violetRoundUp, violet90: roundedColors.violetRoundUp, violet100: roundedColors.violetRoundUp }, namedPalette2023);
const colorByUsageName = {
    text: Object.assign(Object.assign({}, namedPalette2023.text), { primary: {
            white: namedPalette2023.text.inverse,
            black: namedPalette2023.text.default,
            blue: designSystemColors.accent.foreground.informational,
            green: designSystemColors.primary,
        } }),
    web: {
        hover: namedPalette2023.hoverFocus,
        primary: {
            hover: namedPalette2023.hoverFocus,
            disabled: namedPalette2023.primaryDisabled,
        },
        secondary: {
            hover: designSystemColors.backgroundDeemphasized,
            disabled: namedPalette2023.secondaryDisabled,
        },
        error: {
            hover: designSystemColors.specialUse.hover,
            disabled: namedPalette2023.specialUse.disabled,
        },
    },
};
const colors = Object.assign(Object.assign({}, designSystemColors), colorByUsageName);

export { colors };
//# sourceMappingURL=colors.js.map
